import $ from 'jquery';

export default class Responsive {
  constructor() {
    this.modifyDOM();
    this.addEvents();
    this.setResponsiveClass();
  }

  modifyDOM() {
  }

  addEvents() {
    $(window).on('resize', this.setResponsiveClass);
  }

  setResponsiveClass() {
    const width = $(window).width();

    if (width <= 543) {
      $('body').removeClass('desktop tablet').addClass('phone');
    } else if (width > 543 && width <= 985) {
      $('body').removeClass('desktop phone').addClass('tablet');
    } else {
      $('body').removeClass('phone tablet').addClass('desktop');
    }
  }
}
